export default "__VITE_ASSET__JVYzC7be__"